import styled from 'styled-components';

export const StyledPage = styled.div`
    background-color: black;
    min-height: 100vh;
    width: 100%;
    margin: 0 auto;
`;
